import { useEffect } from "react";



export default function BillingRedirect(data) {



  useEffect(() => {
    window.location.href = "https://stripe.com/checkout";  // This component is never used, the redirect happens in accountinfo in the redirectToCheckout() function


  }, []);

  return <p>Redirecting to secure billing...</p>;
}

